import React from "react";
import Desktop from "./Desktop";

export default function View(props) {
  // TODO:
  // Use media query or device dimensions to get the device type
  // Based on device type - render the corresponding content in Desktop or mobile
  return <Desktop {...props} />;
}
